import SpriteSymbol from "../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.store/svg-sprite-loader@4.3.0/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-share",
  "use": "icon-share-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-share\">\n<path d=\"M147.7,13.5c-12.5,0-25.6,2.8-37.6,7.1c3.8,25.6,17.4,49,37.6,64.8c20.2-15.8,33.7-39.2,37.6-64.8\n\tC173.2,16.2,160.2,13.5,147.7,13.5z\" />\n<circle cx=\"48\" cy=\"99\" r=\"37.3\" />\n<circle cx=\"147.7\" cy=\"153.5\" r=\"33\" />\n<rect x=\"87.8\" y=\"28.8\" transform=\"matrix(0.5 0.866 -0.866 0.5 107.4463 -48.9606)\" width=\"16.7\" height=\"79.6\" />\n<rect x=\"89.8\" y=\"94.9\" transform=\"matrix(-0.5 0.866 -0.866 -0.5 261.7113 113.2282)\" width=\"16.7\" height=\"74.5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/share.svg
// module id = BDVe
// module chunks = 3